import { Format, StyleColor } from '../../../utils/styles-constants';
import { styled, component } from '../../../utils/style';
import { Button } from '../../../components/Button/styles';
import { Input } from '../../../components/Form/styles';

interface StyledSharePanelProps {
	isOpen: boolean;
}

const panelHeight = 470;

const panelHeightSmartphone = 800;
const panelAndShadowHeightSmartphone = panelHeightSmartphone + 2;
export const StyledSharePanel = styled<StyledSharePanelProps>()(component.div, 'StyledSharePanel') `
	background-color: ${StyleColor.White};
	box-shadow: ${StyleColor.Grey300} 1px 1px 1px;
	height: ${panelHeight}px;
	width: 100%;
	position: absolute;
	top: ${props => props.isOpen ? 0 : '-' + panelAndShadowHeightSmartphone}px;
	z-index: 15;
	transition: top 0.4s;
	/*
	panelAndShadowHeightSmartphone is used for the top property because of visual bug :
	the panel was appearing for 0.1s when resizing window width from 1200px to 1199px
	*/

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		top: ${props => props.isOpen ? 0 : '-' + panelAndShadowHeightSmartphone}px;
		height: 100%;
		max-height:${panelHeightSmartphone}px;
	}
`;

export const SharePanelHeader = styled()(component.div, 'SharePanelHeader') `
	height: 44px;
	width: 100%;
	border-bottom: 1px solid ${StyleColor.Grey300};
`;

export const SharePanelHeaderContainer = styled()(component.div, 'SharePanelHeaderContainer') `
	margin: 0 90px;
	height: 100%;
	display: flex;
	align-items: center;

	@media ${Format.Smartphone} {
		margin: 0 45px;
	}
`;

export const SharePanelHeaderTitle = styled()(component.span, 'SharePanelHeaderTitle') `
	flex-grow: 1;
	font-size: 16px;
	font-weight: 500;
	color: ${StyleColor.Grey700};
`;

export const SharePanelHeaderClose = styled()(component.span, 'SharePanelHeaderClose') `
	font-size: 13px;
	color: ${props => props.theme.primary.iconsColor};
	cursor: pointer;
	font-weight: regular;
`;

export const SharePanelContent = styled()(component.div, 'SharePanelContent') `
	height: 425px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	-webkit-overflow-scrolling: touch;
	overflow-y: auto;
	overflow-x: hidden;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		height: calc( 100% - 45px );
		max-height: 760px;
	}
`;

export const SharePanelContentContainer = styled()(component.div, 'SharePanelContentContainer') `
	width: 1140px;
	height: 300px;
	display: flex;
	flex-direction: row;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		flex-direction: column;
		align-self: flex-start;
		align-items: center;
		width: 100%;
		margin-top: 25px;
		margin-left: 35px;
		margin-right: 35px;
		width: calc(100% - 70px);
		max-width: 710px;
	}
`;

export const SharePanelContentSelection = styled()(component.div, 'SharePanelContentSelection') `
	background-color: ${StyleColor.Grey50};
	padding: 35px 30px;
	width:360px;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		width: calc(100% - 60px);
	}
`;

export const SharePanelContentSelectionTitle = styled()(component.div, 'SharePanelContentSelectionTitle') `
	text-transform: uppercase;
	font-size: 14px;
	font-weight: 500;
	color: ${StyleColor.Grey500};
	margin-bottom: 20px;
`;

export const SharePanelContentSelectionContent = styled()(component.div, 'SharePanelContentSelectionContent') `
	font-size: 14px;
	font-weight: 500;
	color: ${StyleColor.Grey800};
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
`;

export const SharePanelContentRight = styled()(component.div, 'SharePanelContentRight') `
	width: 710px;
	margin-left:30px;
	display: flex;
	flex-direction: column;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		margin-left: 0;
		width: 100%;
	}
`;

export const SharePanelContentRightMethods = styled()(component.div, 'SharePanelContentRightMethods') `
	min-height: 60px;
	display: flex;
	flex-direction: row;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		margin-top: 20px;
		justify-content: space-around;
	}
	@media ${Format.Smartphone} {
		min-height: 35px;
	}
`;

export const SharePanelContentForm = styled()(component.div, 'SharePanelContentForm') `
	margin-top: 30px;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		margin-top: 0;
	}
`;

export const SharePanelContentFormTitle = styled()(component.div, 'SharePanelContentFormTitle') `
	margin-bottom: 20px;
	height: 20px;
	font-size: 16px;
	font-weight: 500;
	color: ${StyleColor.Grey700};

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		margin: 20px 0;
		font-size: 20px;
		font-weight: 400;
	}
`;

export const SharePanelContentFormContent = styled()(component.form, 'SharePanelContentFormContent') `
	display: flex;
	flex-direction: row;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		flex-direction: column;
	}
`;

export const SharePanelContentFormContentLeft = styled()(component.div, 'SharePanelContentFormContentLeft') `
	display: flex;
	flex-direction: column;
	width: 360px;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		width: 100%;
	}
`;

export const SharePanelContentFormContentRight = styled()(component.div, 'SharePanelContentFormContentRight') `
	display: flex;
	flex-direction: column;
	width: 360px;
	margin-left: 30px;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		margin-left: 0;
		width: 100%;
	}
`;


export const ShareInput = Input.extend`
	margin-bottom: 10px;
`;

export const ShareInputLast = Input.extend`
	margin-bottom: 0px;
`;

export const ShareButton = Button.extend`
	border-color: ${StyleColor.Blue};
	background-color: ${StyleColor.Blue};
	color: ${StyleColor.White};
	margin: 10px 0 0 0;
	max-height: 50px;

	@media (hover: hover) {
		&:hover {
			border-color: ${StyleColor.Blue};
			background-color: ${StyleColor.Blue};
			color: ${StyleColor.White};
		}
	}

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		align-self: center;
		width: 260px;
		max-width: 260px;
		height: 60px;
		margin: 25px 0;
	}
`;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Share/Panel/styles.ts